var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,32h-72V0H100.688L0,100.688V496h400V192h72c13.232,0,24-10.768,24-24V56C496,42.768,485.232,32,472,32z M96,27.312 V96H27.312L96,27.312z M384,480H16V112h96V16h272v16H184c-13.232,0-24,10.768-24,24v112c0,13.232,10.768,24,24,24h200V480z  M480,168c0,4.408-3.592,8-8,8H184c-4.408,0-8-3.592-8-8V56c0-4.408,3.592-8,8-8h288c4.408,0,8,3.592,8,8V168z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 16,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197,64 L243,160 M243,64 L197,160",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,64 V152 H320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,72 H360 Q344,72 344,88 V96 Q344,112 360,112 H368 Q384,112 384,128 V136 Q384,152 368,152 H344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,64 L459,160 M459,64 L413,160",
    strokeLinecap: "butt"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 232,
    width: 256,
    height: 208
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 284,
    x2: 328,
    y2: 284
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 336,
    x2: 328,
    y2: 336
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 388,
    x2: 328,
    y2: 388
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157,
    y1: 232,
    x2: 157,
    y2: 440
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 232,
    x2: 243,
    y2: 440
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.c56279b3ea9aeb05a076bb77be98e408.svg";
export { ForwardRef as ReactComponent };